import Lenis from 'lenis';

let lenis = null;

export function initLenis() {
    if (lenis) return lenis;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function getLenis() {
    return lenis;
}

export function scrollToId(id) {
    if (lenis) {
        lenis.scrollTo(id, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
    }
}

export function scrollToTop(immediate = true) {
    if (lenis) {
        lenis.scrollTo(0, { immediate });
    } else {
        window.scrollTo(0, 0);
    }
}
